import { Controller } from "@hotwired/stimulus"

// Keeps the open duty pane in the address (?duty=ID), so a pane can be linked
// and comes back after a save or a reload. detail-modal does the opening and
// closing; this only watches it: a click on a duty's title writes the id,
// the pane closing (sidebar or phone sheet) removes it, and a page that loads
// with ?duty= opens that duty, unfolding its process first.
export default class extends Controller {
    connect() {
        this._onClick = (event) => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
            let trigger = event.target.closest("[data-duty-id][data-detail-url]")
            if (trigger && this.element.contains(trigger)) this._remember(trigger.dataset.dutyId)
        }
        this.element.addEventListener("click", this._onClick, true)

        this._observer = new MutationObserver(() => this._forgetWhenClosed())
        let phone = document.querySelector(".assistant-phone")
        if (phone) this._observer.observe(phone, { attributes: true, attributeFilter: ["class"] })
        this._observer.observe(document.body, { attributes: true, attributeFilter: ["class"] })

        // After the page settles: the app's own panels close any detail
        // sidebar while they start up, which shut a pane opened at connect.
        let id = new URL(window.location.href).searchParams.get("duty")
        if (id) this._openTimer = setTimeout(() => this._openOnLoad(id), 400)
    }

    disconnect() {
        clearTimeout(this._openTimer)
        this.element.removeEventListener("click", this._onClick, true)
        this._observer?.disconnect()
    }

    _openOnLoad(id) {
        let trigger = this.element.querySelector(`[data-duty-id="${CSS.escape(id)}"][data-detail-url]`)
        if (!trigger) return

        let steps = trigger.closest(".playbook-process-steps")
        if (steps?.hidden) steps.closest(".playbook-process")?.querySelector(".playbook-process-caret")?.click()
        trigger.scrollIntoView({ block: "center" })
        trigger.click()
    }

    _isOpen() {
        return document.querySelector(".assistant-phone")?.classList.contains("is-detail-open") || document.body.classList.contains("email-modal-open")
    }

    _forgetWhenClosed() {
        if (!this._isOpen()) this._remember(null)
    }

    _remember(id) {
        let url = new URL(window.location.href)
        if (id) url.searchParams.set("duty", id)
        else url.searchParams.delete("duty")
        if (url.href !== window.location.href) window.history.replaceState(window.history.state, "", url)
    }
}
